/**
 * backDoor.tsx
 */
import Content from '@shared/types/enums/content';
import MainTemplate from '@components/templates/main/ui/main';
import Rail from '@shared/classes/rail';
import { RailDisplayMode } from '@shared/types/enums/rail';

/**
 * Displays the back door page with the rails.
 * The backdoor page is a hidden page that is used to access different versions of the app.
 */
export default function BackDoor() {
  /* TIVIFY */
  const TivifyProdSamsung = {
    channelId: '',
    channelName: '',
    duration: 0,
    eventId: 'https://smarttv.tvup.cloud',
    kind: Content.BACK_DOOR,
    moviePictures: {
      background: '',
      photo:
        'https://play-lh.googleusercontent.com/_6qBNrIrZFM-M1d6QDdIjRyBJko_mi-oE8ZZK5_x9JRVFdbxQUccDTRvrI_s9Q-iW9Y',
      poster: '',
    },
    title: 'Tivify Prod',
    url: '',
  };
  const TivifyPreprodSamsung = {
    channelId: '',
    channelName: '',
    duration: 0,
    eventId: 'https://smarttvpreproduction.tvup.cloud/SAMSUNG',
    kind: Content.BACK_DOOR,
    moviePictures: {
      background: '',
      photo:
        'https://play-lh.googleusercontent.com/_6qBNrIrZFM-M1d6QDdIjRyBJko_mi-oE8ZZK5_x9JRVFdbxQUccDTRvrI_s9Q-iW9Y',
      poster: '',
    },
    title: 'Tivify Preproduction',
    url: '',
  };
  const TivifyStageSamsung = {
    channelId: '',
    channelName: '',
    duration: 0,
    eventId: 'https://smarttvstage.tvup.cloud/SAMSUNG/',
    kind: Content.BACK_DOOR,
    moviePictures: {
      background: '',
      photo:
        'https://play-lh.googleusercontent.com/_6qBNrIrZFM-M1d6QDdIjRyBJko_mi-oE8ZZK5_x9JRVFdbxQUccDTRvrI_s9Q-iW9Y',
      poster: '',
    },
    title: 'Tivify Stage',
    url: '',
  };

  const TivifyProdLG = {
    channelId: '',
    channelName: '',
    duration: 0,
    eventId: 'https://smarttv.tvup.cloud/LG/',
    kind: Content.BACK_DOOR,
    moviePictures: {
      background: '',
      photo:
        'https://play-lh.googleusercontent.com/_6qBNrIrZFM-M1d6QDdIjRyBJko_mi-oE8ZZK5_x9JRVFdbxQUccDTRvrI_s9Q-iW9Y',
      poster: '',
    },
    title: 'Tivify Prod',
    url: '',
  };
  const TivifyPreprodLG = {
    channelId: '',
    channelName: '',
    duration: 0,
    eventId: 'https://smarttvpreproduction.tvup.cloud/LG',
    kind: Content.BACK_DOOR,
    moviePictures: {
      background: '',
      photo:
        'https://play-lh.googleusercontent.com/_6qBNrIrZFM-M1d6QDdIjRyBJko_mi-oE8ZZK5_x9JRVFdbxQUccDTRvrI_s9Q-iW9Y',
      poster: '',
    },
    title: 'Tivify Preproduction',
    url: '',
  };
  const TivifyStageLG = {
    channelId: '',
    channelName: '',
    duration: 0,
    eventId: 'https://smarttvstage.tvup.cloud/LG/',
    kind: Content.BACK_DOOR,
    moviePictures: {
      background: '',
      photo:
        'https://play-lh.googleusercontent.com/_6qBNrIrZFM-M1d6QDdIjRyBJko_mi-oE8ZZK5_x9JRVFdbxQUccDTRvrI_s9Q-iW9Y',
      poster: '',
    },
    title: 'Tivify Stage',
    url: '',
  };

  /* MundoGo */
  const MundoGoProdSamsung = {
    channelId: '',
    channelName: '',
    duration: 0,
    eventId: 'https://smarttv.tvup.cloud/SAMSUNG/mundogo',
    kind: Content.BACK_DOOR,
    moviePictures: {
      background: '',
      photo:
        'https://downloadr2.apkmirror.com/wp-content/uploads/2024/01/80/65b12680529b2_cl.mundogo.atv.png',
      poster: '',
    },
    title: 'MundoGo Prod',
    url: '',
  };
  const MundoGoPreprodSamsung = {
    channelId: '',
    channelName: '',
    duration: 0,
    eventId: 'https://smarttvpreproduction.tvup.cloud/SAMSUNG/mundogo',
    kind: Content.BACK_DOOR,
    moviePictures: {
      background: '',
      photo:
        'https://downloadr2.apkmirror.com/wp-content/uploads/2024/01/80/65b12680529b2_cl.mundogo.atv.png',
      poster: '',
    },
    title: 'MundoGo Preproduction',
    url: '',
  };
  const MundoGoStageSamsung = {
    channelId: '',
    channelName: '',
    duration: 0,
    eventId: 'https://smarttvstage.tvup.cloud/SAMSUNG/mundogo',
    kind: Content.BACK_DOOR,
    moviePictures: {
      background: '',
      photo:
        'https://downloadr2.apkmirror.com/wp-content/uploads/2024/01/80/65b12680529b2_cl.mundogo.atv.png',
      poster: '',
    },
    title: 'MundoGo Stage',
    url: '',
  };

  const MundoGoProdLG = {
    channelId: '',
    channelName: '',
    duration: 0,
    eventId: 'https://smarttv.tvup.cloud/LG/mundogo',
    kind: Content.BACK_DOOR,
    moviePictures: {
      background: '',
      photo:
        'https://downloadr2.apkmirror.com/wp-content/uploads/2024/01/80/65b12680529b2_cl.mundogo.atv.png',
      poster: '',
    },
    title: 'MundoGo Prod',
    url: '',
  };
  const MundoGoPreprodLG = {
    channelId: '',
    channelName: '',
    duration: 0,
    eventId: 'https://smarttvpreproduction.tvup.cloud/LG/mundogo',
    kind: Content.BACK_DOOR,
    moviePictures: {
      background: '',
      photo:
        'https://downloadr2.apkmirror.com/wp-content/uploads/2024/01/80/65b12680529b2_cl.mundogo.atv.png',
      poster: '',
    },
    title: 'MundoGo Preproduction',
    url: '',
  };
  const MundoGoStageLG = {
    channelId: '',
    channelName: '',
    duration: 0,
    eventId: 'https://smarttvstage.tvup.cloud/LG/mundogo',
    kind: Content.BACK_DOOR,
    moviePictures: {
      background: '',
      photo:
        'https://downloadr2.apkmirror.com/wp-content/uploads/2024/01/80/65b12680529b2_cl.mundogo.atv.png',
      poster: '',
    },
    title: 'MundoGo Stage',
    url: '',
  };

  const SAMSUNG_RAIL = new Rail({
    section: {
      name: 'samsung',
      presentationType: RailDisplayMode.PHOTO,
      title: 'SAMSUNG',
    },
    shows: {
      data: [
        TivifyProdSamsung,
        TivifyPreprodSamsung,
        TivifyStageSamsung,
        MundoGoProdSamsung,
        MundoGoPreprodSamsung,
        MundoGoStageSamsung,
      ],
    },
  });

  const LG_RAIL = new Rail({
    section: {
      name: 'lg',
      presentationType: RailDisplayMode.PHOTO,
      title: 'LG',
    },
    shows: {
      data: [
        TivifyProdLG,
        TivifyPreprodLG,
        TivifyStageLG,
        MundoGoProdLG,
        MundoGoPreprodLG,
        MundoGoStageLG,
      ],
    },
  });
  const rails = [SAMSUNG_RAIL, LG_RAIL];

  return <MainTemplate flags={{ complete: true }} rails={rails} />;
}
